import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { ShareArticleSection } from "../ShareArticleSection";

const AmazonConnectWithAI = () => {
  return (
    <div className="modal-content-body case-studies-blk">
      <div className="modal-section">
        <div className="flex-content header-modal-case-studies">
          <div className="logo-section-modal">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/fingermark-thumbnail-iris.png"
              alt="FingerMark"
            />
          </div>
          <div>
            <h3>Amazon Connect Launch + iCXeed Managed Service </h3>
            <p>
              Empowering speed, intelligence, and continuous CX innovation with
              a secure, modern cloud contact centre.
            </p>
            <ShareArticleSection />
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Company Snapshot:</h2>
        <p className="title-description-blk">
          Fingermark is an industry leader in enterprise-level QSR (Quick
          Service Restaurant) technology solutions, helping brands across the
          globe deliver faster, smarter, and more accurate guest experiences
          through cutting-edge AI, computer vision, and integrated digital
          platforms.
        </p>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <div className="flex-content-half">
          <div>
            <h2 className="modal-section-title">Challenge:</h2>
            <p>
              With rapid growth and a global customer footprint, Fingermark
              required an agile, scalable customer service platform to match the
              complexity of their technology and the ambition of their clients.
              Legacy tools and fragmented workflows were holding back their
              support teams, increasing resource demands, and making it
              difficult to meet service excellence standards across voice,
              email, and digital channels.
            </p>
          </div>
          <div>
            <h2 className="modal-section-title">AWS Solution:</h2>
            <p>
              Partnering with iCXeed, Fingermark launched Amazon Connect as a
              next-generation global cloud contact centre. The solution provided
              a unified platform to streamline omnichannel voice, email, chat,
              SMS, and task management, all with enterprise-grade reliability
              and integrated analytics. The roll-out included robust managed
              services - covering round-the-clock monitoring, incident response,
              system health checks, security best practices, and flexible change
              management - to support continuous improvement and ensure global
              uptime.
            </p>
          </div>
        </div>
      </div>

      <div className="outcomes-result-blk">
        <h2 className="modal-section-title">Outcomes/Results:</h2>
        <ul>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                50% reduction in CX technology stack costs and 40% reduction in
                contact centre workload through automation and analytics.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Embedded workforce management, advanced reporting, and proactive
                incident/resolution workflows keep agents productive and
                customers satisfied.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Flexible managed service model, providing ongoing support,
                maintenance, and innovation - tailored to Fingermark's evolving
                needs.
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div className="modal-footnote use-cases-footnote" style={{ border: 0 }}>
        <h4>Client Testimonial</h4>
        <h1>
          "iCXeed was a natural addition to our growing business, providing
          simple and easy engagement, project management, and subject-matter
          experts who go out of their way for us. As a partner we chose for our
          Amazon Connect implementation, they've eliminated any fear or risk of
          impact, creating a 'so-what' feature that transforms our excellent
          capabilities into a platform for future innovation as we expand across
          other markets in a cost-effective, technology-smart way. This was
          about finding a partner who understood our vision and helped to
          deliver an omnichannel communication tool to promote excellence in
          customer service."
        </h1>
        <div className="flex-box-blk client-details">
          <div>
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/james-baird.png"
              alt="James Baird"
            />
          </div>
          <div>
            <h2>James Baird</h2>
            <p>VP Operational Excellence</p>
            <p>Fingermark</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmazonConnectWithAI;
